import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import DeleteIcon from '../../assets/icon-google-delete.svg?react';
import ElysiaBrainIcon from '../../assets/icon-elysia-brain.svg?react';

interface DeleteModalProps {
  deleteSourceById: (id?: string, transcriptionId?: string) => void;
  documentId?: string;
  deleteIconVisible?: boolean;
  showDeletePopup?: boolean;
  setShowDeletePopup?: (arg: boolean) => void;
  deleteMessage?: string;
  deleteHeading?: string;
  transcriptionId?: string;
  isDisabled?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  deleteSourceById,
  documentId,
  deleteIconVisible,
  showDeletePopup = false,
  setShowDeletePopup,
  deleteMessage = 'You have chosen to delete this file, it will be deleted forever.',
  deleteHeading = 'Delete item',
  transcriptionId = '',
  isDisabled,
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setShowDeletePopup?.(false);
  };
  const handleShow = () => setShow(true);

  const handleDeleteDoc = () => {
    if (documentId) {
      deleteSourceById?.(documentId, transcriptionId);
    } else {
      deleteSourceById();
    }
    handleClose();
  };

  useEffect(() => {
    if (deleteIconVisible) {
      setShow(showDeletePopup);
    }
  }, [deleteIconVisible, showDeletePopup]);

  return (
    <>
      {!deleteIconVisible && (
        <Button
          disabled={isDisabled}
          className="content-delete-option"
          title="Delete"
          onClick={handleShow}
        >
          <DeleteIcon />
        </Button>
      )}
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="delete-modal"
        backdropClassName="delete-modal-backdrop"
        data-testid="delete-file-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title data-testid="delete-item">{deleteHeading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!deleteIconVisible && <ElysiaBrainIcon />}
          <span data-testid="delete-modal-sub-heading">{deleteMessage}</span>
          <br />
          <span data-testid="delete-file-modal-confirmation" className="delete-confirm-msg">
            Are you sure you want to delete it?
          </span>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-cancel"
            data-testid="delete-modal-cancel-button"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="modal-proceed"
            data-testid="delete-modal-proceed-button"
            variant="primary"
            onClick={handleDeleteDoc}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteModal;
